export default "__VITE_ASSET__BrDeZX$C__"